/* eslint-disable no-console */
import { LOCAL_URl } from '.';
import { API_URL } from '../utils/constants';

const login = async (email: string, password: string) => {
  return await fetch(`${LOCAL_URl}/auth/email-password`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({ email, password })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};

const sendOtp = async (email: string) => {
  return await fetch(`${LOCAL_URl}/auth/email-otp`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({ email })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log('Error:', err));
};
const verifyOtp = async (email: string, otp: number) => {
  return await fetch(`${LOCAL_URl}/auth/email-otp/verify`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({ email, otp, role: 'tutor' })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};

const acceptTermsOfUsage = async (id: string) => {
  return await fetch(`${LOCAL_URl}/accept-terms-of-usage`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify({ id })
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};

const signInWithGoogle = async () => window.open(`${LOCAL_URl}/auth/google/tutor`, '_self');

const authStatus = async () => {
  return await fetch(`${LOCAL_URl}/authStatus`, {
    credentials: 'include',
    headers: {
      'Content-type': 'application/json'
    }
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};

const logout = async () => {
  return await fetch(`${API_URL}/logout`, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json'
    },
    credentials: 'include'
  })
    .then((res) => res.json())
    .then((res) => res)
    .catch((err) => console.log(err));
};
const authApi = {
  login,
  logout,
  authStatus,
  signInWithGoogle,
  sendOtp,
  verifyOtp,
  acceptTermsOfUsage
};

export default authApi;
